import { linkedUsersLabel } from "./role-in-use-dialog.constants";
import type { RoleInUseDialogProps, RoleInUseDialogViewModel } from "./types-role-in-use-dialog";

/** Quantidade de usuários vinculados e o rótulo no singular ou no plural (RN03 da HU 870). */
export function useRoleInUseDialog({
  role,
  onClose,
  onGoToUsers,
}: RoleInUseDialogProps): RoleInUseDialogViewModel {
  const count = role.quantidadeUsuarios;

  return { role, count, countLabel: linkedUsersLabel(count), onClose, onGoToUsers };
}
